export const cssManualButtonWhitelist = ['pointer-events', 'inline-size'];
